import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { DEFIS_MAISON_DEFAUT, DEFIS_ECOLE_DEFAUT, RECOMPENSES_DEFAUT, semaineCourante } from '../lib/helpers'

export default function TableauDeBord() {
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [enfants, setEnfants] = useState([])
  const [loading, setLoading] = useState(true)
  const [ajoutOuvert, setAjoutOuvert] = useState(false)
  const [pseudonyme, setPseudonyme] = useState('')
  const [consentement, setConsentement] = useState(false)
  const [saving, setSaving] = useState(false)
  const [erreur, setErreur] = useState('')

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      if (!data.user) return navigate('/connexion')
      setUser(data.user)
      chargerEnfants(data.user.id)
    })
  }, [])

  const chargerEnfants = async (parentId) => {
    const { data } = await supabase.from('enfants').select('*').eq('parent_id', parentId).order('created_at')
    setEnfants(data || [])
    setLoading(false)
  }

  const genCode = () => Math.random().toString(36).slice(2, 8).toUpperCase()

  const creerEnfant = async (e) => {
    e.preventDefault()
    if (!pseudonyme.trim()) return
    setSaving(true); setErreur('')
    const sc = semaineCourante()
    const codeAcces = genCode()
    const codeTherapeutique = genCode()
    const { data: enfant, error } = await supabase
      .from('enfants')
      .insert({ parent_id: user.id, pseudonyme: pseudonyme.trim(), code_acces: codeAcces, code_therapeute: codeTherapeutique })
      .select().single()
    if (error) { setSaving(false); return setErreur('Erreur lors de la création.') }
    const defisInit = [
      ...DEFIS_MAISON_DEFAUT.map(d => ({ ...d, enfant_id: enfant.id, actif: true, debut_semaine: sc })),
      ...DEFIS_ECOLE_DEFAUT.map(d => ({ ...d, enfant_id: enfant.id, actif: true, debut_semaine: sc })),
    ]
    await supabase.from('defis').insert(defisInit)
    const recompInit = RECOMPENSES_DEFAUT.map(r => ({ ...r, enfant_id: enfant.id }))
    await supabase.from('recompenses').insert(recompInit)
    setSaving(false); setPseudonyme(''); setConsentement(false); setAjoutOuvert(false)
    chargerEnfants(user.id)
  }

  const deconnecter = async () => { await supabase.auth.signOut(); navigate('/') }

  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', fontSize:16, color:'#64748b', fontFamily:"'Inter',sans-serif" }}>Chargement...</div>

  return (
    <div style={{ minHeight:'100vh', background:'#f8fafc', fontFamily:"'Inter',sans-serif" }}>
      <header style={{ background:'#fff', borderBottom:'1px solid #e2e8f0', padding:'0 24px', height:56 }}>
        <div style={{ maxWidth:900, margin:'0 auto', height:'100%', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <rect width="28" height="28" rx="6" fill="#2563eb"/>
              <path d="M8 14l4 4 8-8" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:18, color:'#1e293b' }}>KudoGenius</span>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <span style={{ color:'#94a3b8', fontSize:12 }}>{user?.email}</span>
            <button onClick={deconnecter} style={{ padding:'6px 14px', borderRadius:6, border:'1px solid #e2e8f0', background:'#fff', color:'#64748b', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
              Déconnexion
            </button>
          </div>
        </div>
      </header>

      <main style={{ maxWidth:900, margin:'0 auto', padding:'32px 20px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <div>
            <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:24, fontWeight:700, color:'#1e293b', margin:0 }}>Tableau de bord</h1>
            <p style={{ color:'#94a3b8', fontSize:13, marginTop:4 }}>Gérez les profils de vos enfants</p>
          </div>
          <button onClick={() => setAjoutOuvert(!ajoutOuvert)} className="btn">
            + Ajouter un enfant
          </button>
        </div>

        {ajoutOuvert && (
          <div className="card fade-in" style={{ marginBottom:24 }}>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:16, fontWeight:700, marginBottom:16, color:'#1e293b' }}>Nouvel enfant</h3>
            <form onSubmit={creerEnfant} style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'flex-end' }}>
              <div style={{ flex:1, minWidth:200 }}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, color:'#374151', marginBottom:5 }}>Pseudonyme</label>
                <input value={pseudonyme} onChange={e => setPseudonyme(e.target.value)} className="input" placeholder="Ex: SuperHéros, Lutin..." required />
              </div>
              <div style={{ width:'100%', marginTop: 4 }}>
              <label style={{ display:'flex', alignItems:'flex-start', gap: 8, cursor:'pointer', fontSize: 12, color:'#475569', lineHeight: 1.5 }}>
                <input type="checkbox" checked={consentement} onChange={e => setConsentement(e.target.checked)} style={{ marginTop: 3, accentColor:'#16a34a' }} />
                <span>
                  Je certifie être titulaire de l'autorité parentale et j'accepte que les données
                  de mon enfant soient traitées conformément à la{" "}
                  <a href="/politique-confidentialite" target="_blank" style={{ color:'#2563eb', textDecoration:'underline' }}>
                    politique de confidentialité
                  </a>.
                </span>
              </label>
            </div>
            <div style={{ display:'flex', gap:8 }}>
                <button type="submit" className="btn btn-green" disabled={saving || !consentement}>{saving ? 'Création...' : 'Créer'}</button>
                <button type="button" className="btn btn-ghost" onClick={() => setAjoutOuvert(false)}>Annuler</button>
              </div>
            </form>
            {erreur && <p style={{ color:'#dc2626', fontSize:12, marginTop:10 }}>{erreur}</p>}
            <p style={{ color:'#94a3b8', fontSize:11, marginTop:12 }}>Aucun nom de famille ni date de naissance requis — pseudonyme uniquement.</p>
          </div>
        )}

        {enfants.length === 0 ? (
          <div className="card" style={{ textAlign:'center', padding:'48px 24px' }}>
            <div style={{ width:64, height:64, borderRadius:'50%', background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:700, marginBottom:8, color:'#1e293b' }}>Aucun enfant encore</h3>
            <p style={{ color:'#64748b', marginBottom:24, fontSize:14 }}>Ajoutez votre premier enfant pour commencer</p>
            <button onClick={() => setAjoutOuvert(true)} className="btn">+ Ajouter un enfant</button>
          </div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:16 }}>
            {enfants.map(enfant => (
              <div key={enfant.id} className="card" style={{ cursor:'pointer', transition:'all 0.15s' }}
                onClick={() => navigate(`/enfant/${enfant.id}`)}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#2563eb'; e.currentTarget.style.boxShadow='0 4px 20px rgba(37,99,235,0.1)' }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='#e2e8f0'; e.currentTarget.style.boxShadow='' }}
              >
                <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:16 }}>
                  <div style={{ width:44, height:44, borderRadius:'50%', background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:18, color:'#2563eb' }}>
                      {enfant.pseudonyme.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:17, color:'#1e293b' }}>{enfant.pseudonyme}</div>
                  </div>
                </div>

                {/* Code école */}
                <div style={{ background:'#f0f9ff', borderRadius:10, padding:'10px 14px', marginBottom:10, border:'1px solid #bae6fd', display:'flex', alignItems:'center', justifyContent:'space-between' }}
                  onClick={e => e.stopPropagation()}>
                  <div>
                    <div style={{ fontSize:10, color:'#0369a1', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:2 }}>Code école</div>
                    <div style={{ fontSize:20, fontWeight:800, color:'#0369a1', letterSpacing:4, fontFamily:"'Inter',sans-serif" }}>{enfant.code_acces}</div>
                  </div>
                  <button onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(enfant.code_acces) }}
                    style={{ padding:'5px 12px', borderRadius:6, border:'1px solid #bae6fd', background:'#fff', color:'#0369a1', fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
                    Copier
                  </button>
                </div>

                {/* Code Équipe thérapeutique */}
                {enfant.code_therapeute && (
                  <div style={{ background:'#f0f9ff', borderRadius:10, padding:'8px 14px', marginBottom:14, border:'1px solid #e0f2fe', display:'flex', alignItems:'center', justifyContent:'space-between' }}
                    onClick={e => e.stopPropagation()}>
                    <div>
                      <div style={{ fontSize:10, color:'#0369a1', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:2 }}>Code équipe thérapeutique</div>
                      <div style={{ fontSize:16, fontWeight:800, color:'#0369a1', letterSpacing:3, fontFamily:"'Inter',sans-serif" }}>{enfant.code_therapeute}</div>
                    </div>
                    <button onClick={e => { e.stopPropagation(); navigator.clipboard.writeText(enfant.code_therapeute) }}
                      style={{ padding:'4px 10px', borderRadius:6, border:'1px solid #e0f2fe', background:'#fff', color:'#0369a1', fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
                      Copier
                    </button>
                  </div>
                )}

                <button className="btn btn-secondary" style={{ width:'100%', justifyContent:'center' }}
                  onClick={e => { e.stopPropagation(); navigate(`/enfant/${enfant.id}`) }}>
                  Ouvrir le tableau
                </button>
                <button style={{ width:'100%', marginTop: 8, padding:'8px', background:'none', border:'none', color:'#dc2626', fontSize: 11, cursor:'pointer', fontFamily:"'Inter',sans-serif", opacity: 0.5 }}
                  onClick={async (e) => {
                    e.stopPropagation()
                    if (!window.confirm(`Supprimer ${enfant.pseudonyme} et toutes ses données ? Cette action est irréversible.`)) return
                    if (!window.confirm('Êtes-vous vraiment sûr(e) ? Toutes les données (défis, saisies, notes, récompenses) seront définitivement supprimées.')) return
                    const { error } = await supabase.rpc('supprimer_enfant', { p_enfant_id: enfant.id })
                    if (error) { alert('Erreur lors de la suppression : ' + error.message); return }
                    chargerEnfants(user.id)
                  }}>
                  Supprimer cet enfant
                </button>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop:40, padding:'16px 20px', background:'#fff', borderRadius:10, border:'1px solid #e2e8f0', display:'flex', justifyContent:'center' }}>
          <span style={{ fontSize:12, color:'#94a3b8' }}>Un outil offert par </span>
          <a href="https://nutrygenius.com" target="_blank" rel="noreferrer" style={{ fontSize:12, color:'#2563eb', fontWeight:600, marginLeft:4 }}>NutryGenius®</a>
        </div>
      </main>
    </div>
  )
}
